import React from "react";
import { ReactComponent as DDxAiMessageLogo } from "../../../assets/images/ddx-ai-message-logo.svg";

type AiMessageBubbleProps = {
  text: string;
  boldText?: string; // Now optional
  disabled?: boolean;
};

const AiMessageBubble: React.FC<AiMessageBubbleProps> = ({
  text,
  boldText,
  disabled = false,
}) => {
  const renderText = () => {
    if (!boldText || !text.includes(boldText)) {
      return <>{text}</>; // If boldText is not provided or not found, return plain text
    }

    const splitText = text.split(boldText);
    return (
      <>
        {splitText[0]}
        <span className="font-bold">{boldText}</span>
        {splitText[1]}
      </>
    );
  };

  return (
    <div
      className={`w-full flex flex-row gap-3 items-start ${
        disabled && "opacity-50"
      }`}
    >
      <DDxAiMessageLogo className="min-h-8 min-w-8" />
      <p className="text-[#3D4854] text-sm leading-5 text-left mt-1.5">
        {renderText()}
      </p>
    </div>
  );
};

export default AiMessageBubble;
